import React from 'react';

const ThankYouPage = () => {
  const handleClose = () => {
    window.open('', '_self')?.close();
  };

  return (
    <div
      style={{
        backgroundColor: '#f5f7fa',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: `'Segoe UI', Tahoma, Geneva, Verdana, sans-serif`,
        padding: '1rem',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: '3rem',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px',
          width: '100%',
        }}
      >
        <h1 style={{ color: '#0f1f46', marginBottom: '1rem' }}>
          Thank You!
        </h1>
        <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '2rem' }}>
          Your payment was successful. We appreciate your purchase!
        </p>
      
      </div>
    </div>
  );
};

export default ThankYouPage;
